import { companySocialLinks } from '../../common/config/companyContact';
import LinkedInIcon from '../../assets/images/linkedin.svg';
import InstagramIcon from '../../assets/images/instagram.svg';
import WhatsAppIcon from '../../assets/images/integrations/whatsapp.svg';

function XIcon(props) {
  return <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.64 7.584H.47l8.6-9.835L0 1.154h7.594l5.243 6.932 6.064-6.933ZM17.61 20.644h2.039L6.486 3.24H4.298L17.61 20.644Z"/></svg>;
}

const socialIcons = { LinkedIn: LinkedInIcon, X: XIcon, Instagram: InstagramIcon, WhatsApp: WhatsAppIcon };

export function FooterContact() {
  return <div className="footer-contact">
    <ul className="footer-social">
      {companySocialLinks.map(({ label, href }) => {
        const Icon = socialIcons[label];
        return <li key={label}>
          <a href={href} target="_blank" rel="noopener noreferrer" data-social={label} aria-label={label} title={label}>
            <Icon aria-hidden="true" focusable="false"/>
          </a>
        </li>;
      })}
    </ul>
  </div>;
}
